import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshMe } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/auth/google/session", null, { headers: { "X-Session-ID": sid } });
        window.history.replaceState({}, "", window.location.pathname);
        await refreshMe();
        navigate("/", { replace: true });
      } catch {
        // Failure path: clear the hash, resolve auth state, then bounce to login with an error flag
        window.history.replaceState({}, "", window.location.pathname);
        await refreshMe();
        navigate("/login?err=google", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="max-w-md mx-auto py-16 text-center" data-testid="auth-callback">
      <Loader2 className="w-8 h-8 animate-spin mx-auto text-[#C85A32]" />
      <p className="mt-4 text-[#4A525A]">Signing you in...</p>
    </div>
  );
}
